import { render, staticRenderFns } from "./ConferenceServices.vue?vue&type=template&id=cbdd9ba4&"
import script from "./ConferenceServices.vue?vue&type=script&lang=ts&"
export * from "./ConferenceServices.vue?vue&type=script&lang=ts&"
import style0 from "./ConferenceServices.vue?vue&type=style&index=0&id=cbdd9ba4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports